import React, { } from "react";
import { Button } from "reactstrap";
import "./index.scss";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
const FooterLogo = ({ className = '' }) => {
	const history = useHistory();
	const dashboardUrl = (redirectUrl) => {
		history.push(redirectUrl)
	}
	const logo = useSelector((state) => state?.user?.logo);
	return (
		<>
			<Button color="link p-0"
				onClick={() => dashboardUrl('/dashboard')}
				className={`logo-cell shadow-none ${className}`}>
				{/* {logo ?
					<img className='img-fluid' src={logo} alt='Logo' />
					: <a href="https://gettrained.ai/" target="_blank"><img className="img-fluid" src={require("../../../assets/img/app-logo.png")} alt="Logo" /></a>

				} */}
				<a href="https://gettrained.ai/" target="_blank"><img className="img-fluid" src={require("../../../assets/img/app-logo.png")} alt="Logo" /></a>
			</Button>
		</>
	)
};
export default FooterLogo;